module.exports = __webpack_public_path__ + "media/images/oauth_app_thumb-5f4cadc5cf206bf2905ee9876ed3a3e7.png";